import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PermissionGroup } from '../../models'

export const PermissionGroupMock = Factory.Sync.makeFactory<PermissionGroup>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.alphaNumeric(3)),
  type: Factory.each(() => faker.random.arrayElement([1])), // TO DO: ENUM for types
  user_count: 1,
  permissions: [],
})
